import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-600">
            片库更新、平台升级、热门资讯一手掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-5 md:space-y-6">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-5 group cursor-pointer">
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center border-2 z-10 transition-all duration-300 ${
                  i === 0
                    ? 'bg-primary-500 border-primary-500 text-background-50'
                    : 'bg-background-100 border-background-300 text-foreground-600 group-hover:border-primary-300'
                }`}>
                  <i className={`${i === 0 ? 'ri-flashlight-line' : 'ri-movie-line'} text-sm`}></i>
                </div>

                <div className="flex-1 min-w-0 pb-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-500 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.date}
                    </span>
                    {i === 0 && (
                      <span className="text-[10px] md:text-xs font-medium text-primary-500 bg-primary-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 mt-1 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}